/**
 * Where a Channel Partner notification opens inside the Hub.
 *
 * CP items carry the attributed customer's `service_request_id`, but that
 * request belongs to the customer — a CP can never open it. Service events
 * therefore land on the Hub's Services view filtered to that customer.
 *
 * Mirrored verbatim in the provider app; keep the two copies in sync.
 */
export type HubDestination =
  | { view: 'overview' }
  | { view: 'customers' }
  | { view: 'services'; customerId?: string }
  | { view: 'profile' };

const SERVICE_EVENTS = new Set([
  'channel_partner_service_selected',
  'channel_partner_service_updated',
  'channel_partner_action_required',
  'channel_partner_service_completed',
  'channel_partner_feedback_received',
]);

export function hubDestination(n: { event: string; data: Record<string, string> }): HubDestination {
  if (SERVICE_EVENTS.has(n.event)) {
    const customerId = n.data?.customer_id;
    return customerId ? { view: 'services', customerId: String(customerId) } : { view: 'services' };
  }
  switch (n.event) {
    case 'channel_partner_referral_registered':
      return { view: 'customers' };
    case 'channel_partner_agreement_updated':
      return { view: 'profile' };
    default:
      return { view: 'overview' };
  }
}
